import { CommonModule } from '@angular/common';
import { Component, Input, input } from '@angular/core';

@Component({
  selector: 'app-informative-text',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './informative-text.component.html',
  styleUrl: './informative-text.component.scss'
})
export class InformativeTextComponent {
}
